import OperaTion from './operation';//运营员权限
import UserSet from './user-set'//运营员新增
import UserProductlaunch from './user-product-launch'//官方产样发布和列表放一块管理了
import MemberCategory from './member-category'
import MemberList from './member-list'
import ProductauditList from './product-audit-list'
import MemberFabricapply from './member-fabric-apply'
import MemberMainproduct from './member-main-product'
import Baseproduct from './base-product'
import Yyyhaoprofile from './yyyhao-profiles'
export default {
    OperaTion,
    UserSet,
    UserProductlaunch,
    MemberCategory,
    MemberList,
    ProductauditList,
    MemberFabricapply,
    MemberMainproduct,
    Baseproduct,
    Yyyhaoprofile

}